import * as React from "react";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

export default function ScrollablePageTab({
  selectedPage,
  setSelectedPage,
  dynamicFormPages,
  maxWidthValue,
  tabsOrientation,
  noMarginTop,
  reportTabId,
}) {
  const handleChangeSelectedPage = (event, newValue) => {    
    setSelectedPage(newValue);
  };

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        flexGrow: 1,
        width: "100%",
        maxWidth: maxWidthValue ?? "100%",
        justifyContent: "center",
      }}
      className={`${
        noMarginTop ? "" : "mt-5"
      } flex lg:items-center xl:items-center`}
    >
      <Tabs
        orientation={tabsOrientation ?? "horizontal"}
        value={reportTabId ? parseInt(selectedPage) : selectedPage}
        onChange={handleChangeSelectedPage}
        scrollButtons
        allowScrollButtonsMobile
        variant="scrollable"
        sx={{
          [`& .${tabsClasses.scrollButtons}`]: {
            "&.Mui-disabled": { opacity: 0.3 },
          },
        }}
      >
        {dynamicFormPages &&
          dynamicFormPages.map((page) => (
            <Tab
              value={reportTabId ? page.Id : undefined}
              key={page.Id}
              sx={{ fontSize: "0.8em", whiteSpace: "nowrap" }}
              label={page?.Name}
            />
          ))}
      </Tabs>
    </Box>
  );
}
